import usePrivateAxios from "@/common/api/usePrivateAxios";
import { useQuery } from "@tanstack/react-query";
import { MaintenanceObjectiveActionsData } from "../types/MaintenanceObjectiveActions.type";

const useMaintenanceObjectiveAction = (id?: string) => {
  const privateAxios = usePrivateAxios();

  return useQuery<{ data: { data: MaintenanceObjectiveActionsData } }, unknown, MaintenanceObjectiveActionsData>({
    enabled: !!id,
    queryKey: ['maintenanceObjectiveAction', id],
    queryFn: () => privateAxios.get(`/maintenance/objective_actions/${id}`),
    select: (data) => data?.data?.data,
  });
}

export default useMaintenanceObjectiveAction;
